import Marquee from "react-fast-marquee";
import { useT } from "../../i18n/I18nProvider";

export const HomeMarquee = () => {
  const t = useT();
  const marqueeTags = t("home.marquee");

  return (
    <section
      className="border-y border-ink-200 py-4 md:py-6 bg-white/60"
      data-testid="home-marquee"
    >
      <Marquee gradient={false} speed={38} pauseOnHover>
        {marqueeTags.concat(marqueeTags).map((mt, i) => (
          <div key={`${mt}-${i}`} className="flex items-center gap-6 md:gap-8 pr-6 md:pr-8">
            <span className="font-editorial text-2xl md:text-4xl text-ink-900">
              {mt}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-ink-300" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
